import { decodeToken } from 'react-jwt'
import { ITokenParseUser } from 'models/auth'
import { TOKEN } from 'shared/constants/app'

const getTokenUserId = (token?: string | null): string | null => {
  if (!token) return null
  const user = decodeToken(token) as ITokenParseUser | null
  return user?._id ?? null
}

// Сессия панели и сессия сайта живут на одном домене API, поэтому обновление
// токенов может вернуть другой аккаунт — молча подменять пользователя нельзя
export const isSameTokenUser = (nextToken: string): boolean => {
  const currentUserId = getTokenUserId(localStorage.getItem(TOKEN))
  if (!currentUserId) return true
  return getTokenUserId(nextToken) === currentUserId
}
